export function formatMillisecondsToMinutesSeconds(ms: number | null | undefined) {
  if (ms == null) return null;

  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes: String(minutes), seconds: String(seconds).padStart(2, '0') };
}

interface CalculateGrantedManualDurationParams {
  rawManual: number | null | undefined;
  rawAuto: number | null | undefined;
  maxExtendable: number | null | undefined;
}

export function calculateGrantedManualDurationInMs({
  rawManual,
  rawAuto,
  maxExtendable,
}: CalculateGrantedManualDurationParams) {
  const manual = rawManual ?? 0;
  const auto = rawAuto ?? 0;
  const cap = maxExtendable ?? Number.POSITIVE_INFINITY;
  const total = manual + auto;

  if (total < cap) return manual;

  const capInSeconds = Math.ceil(cap / 1_000);
  const autoInSeconds = Math.ceil(auto / 1_000);

  return Math.max(0, (capInSeconds - autoInSeconds) * 1_000);
}
